import getTopics from 'services/apiHelpers/getTopics';
import getStore from 'services/getStore';
import { updateInteractionsOpenAction } from 'actions/updateInteractionsOpenAction';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import setCurrentTopic from 'services/apiHelpers/setCurrentTopic';
import onScrollEnds from 'services/onScrollEnds';
import { Block } from '@chameleoncreator/creator-app';
import { getTopicsNotHiddenFromNextAndBackNavigation } from 'services/getTopicsNotHiddenFromNextAndBackNavigation';

const store = getStore();

let checkWindowHasScrolled;

const navToNextTopic = () => {
  const topics = getTopics();

  const topicsNotHiddenFromNextAndBackNavigation = getTopicsNotHiddenFromNextAndBackNavigation(
    topics
  );

  const nextTopic =
    topicsNotHiddenFromNextAndBackNavigation[
      topicsNotHiddenFromNextAndBackNavigation.findIndex(
        t => t.id === (getCurrentTopic() as Block).id
      ) + 1
    ];

  if (!nextTopic) return;

  setCurrentTopic(nextTopic.id);

  window.scrollTo(0, 0);

  if (
    window['CHAMELEON_EVENTS_API'] &&
    typeof window['CHAMELEON_EVENTS_API'] === 'function'
  ) {
    window['CHAMELEON_EVENTS_API']('NAVIGATION_TO_NEXT_TOPIC');
  }
};

const next = (sId: number, id: string) => l => {
  if (l !== 'next') {
    // console.log('branching');

    window.location.hash = l;
    return;
  }

  (window as any).locationHistory = null;

  store.dispatch(updateInteractionsOpenAction(id));

  const getNextInteraction = () => {
    // being more specific with the selector here since it appears that certain extensions ' you know loom you are. . . '
    // are injecting section elements onto the page

    // we only want sections that are within a chameleon topic container
    const topicContainer =
      document.querySelector('[class*="TopicContainer"]') ||
      document.querySelector('[class*="AssessmentContainer"]');
    //
    // console.log(topicContainer);

    if (!topicContainer) {
      return;
    }

    const interactions = Array.from(topicContainer.querySelectorAll('section'));

    const nextInteraction: HTMLElement =
      interactions[interactions.findIndex(i => i.id === `i${id}`) + 1];

    // console.log(`'next' navigates to next interaction ?`, nextInteraction);

    return nextInteraction;
  };

  requestAnimationFrame(() => {
    const nextInteraction = getNextInteraction();

    const windowScrollY = window.scrollY;

    clearTimeout(checkWindowHasScrolled);

    if (nextInteraction) {
      nextInteraction.scrollIntoView({
        behavior: 'smooth',
      });

      checkWindowHasScrolled = setTimeout(() => {
        if (window.scrollY === windowScrollY) {
          nextInteraction.scrollIntoView();
          // console.log(
          //   'smooth scrolling failed so we attempt to snap to the nextInteraction'
          // );
        } else {
          // console.log('we have smooth scrolled to the next interaction');
        }
      }, 300);

      //

      onScrollEnds(() => {
        nextInteraction.focus({
          preventScroll: true,
        });
      });
      //
    } else {
      navToNextTopic();
    }
  });
};

export default next;
